<template>

    <div class="input-group">
        <div v-if="prefix || prefixIcon || $slots['prefix']" class="input-group-prepend">
            <div class="input-group-text" :style="prefixStyles">
                <slot v-if="$slots['prefix']" name="prefix"></slot>
                <span v-else-if="prefix">{{ prefix }}</span>
                <span v-else-if="prefixIcon"><i :class="prefixIcon" /></span>
            </div>
        </div>
        <slot></slot>
        <div v-if="suffix || $slots['suffix']" class="input-group-append">
            <div class="input-group-text" :style="suffixStyles">
                <slot v-if="$slots['suffix']" name="suffix"></slot>
                <span v-else-if="suffix">{{ suffix }}</span>
            </div>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .input-group {
        display: flex;
        flex-wrap: nowrap;
        position: relative;
    }

    .input-group-prepend,
    .input-group-append {
        display: flex;
        flex-shrink: 0;
        margin: 0;
        .input-group-text {
            @include font-regular(13px);
            align-items: center;
            background: $color-bg;
            border: 1px solid $color-rule;
            color: $color-text;
            display: flex;
            white-space: nowrap;
            a {
                color: $color-text;
                text-decoration: underline;
                &:hover {
                    opacity: 0.7;
                }
            }
        }
    }

    .input-group-prepend {
        .input-group-text {
            margin-right: -5px;
            padding: 0 20px 0 15px;
        }
    }

    .input-group-append {
        .input-group-text {
            margin-left: -5px;
            padding: 0 15px 0 20px;
        }
    }

</style>

<script>

export default {

    props: {
        prefix: {
            type: String,
        },
        prefixIcon: {
            type: String,
        },
        prefixWidth: {
            type: Number,
        },
        suffix: {
            type: String,
        },
        suffixWidth: {
            type: Number,
        },
    },

    computed: {

        prefixStyles() {
            return {
                'width': this.prefixWidth ? `${this.prefixWidth}px` : 'auto',
            }
        },

        suffixStyles() {
            return {
                'width': this.suffixWidth ? `${this.suffixWidth}px` : 'auto',
            }
        },

    },

}

</script>
